export default "__VITE_ASSET__00630b2f__"